module.exports = __webpack_public_path__ + "static/media/loveseat.ec76b813.svg";